import { useState, useMemo } from "react";
import { RequestStatus } from "@/types/nanny";

interface FilterableRequest {
  status: RequestStatus;
}

export function useFilteredRequests<T extends FilterableRequest>(items: T[]) {
  const [showDeleted, setShowDeleted] = useState(false);

  const filteredItems = useMemo(() => {
    return items.filter(
      (item) => item && (showDeleted || item.status !== "DELETED"),
    );
  }, [items, showDeleted]);

  return {
    filteredItems,
    showDeleted,
    setShowDeleted,
  };
}
